import React from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { usePortalHtmlBlobSrc } from '../../hooks/usePortalHtmlBlobSrc';

export interface HtmlViewerPaneProps {
  url: string;
  fetchUrl?: string;
  title: string;
  iframeRef?: React.Ref<HTMLIFrameElement>;
  chrome?: React.ReactNode;
  /** No model selected yet (compare right pane). */
  empty?: boolean;
}

export default function HtmlViewerPane({
  url,
  fetchUrl,
  title,
  iframeRef,
  chrome,
  empty,
}: HtmlViewerPaneProps) {
  const { iframeSrc, loadState } = usePortalHtmlBlobSrc(url, fetchUrl, !empty && !!url);
  const openHref = fetchUrl || url;

  return (
    <div className="html-viewer-pane">
      {chrome ? <div className="html-viewer-pane-chrome">{chrome}</div> : null}
      {empty || !url ? (
        <div className="html-viewer-status">
          <span>Pick a 3D model to compare</span>
        </div>
      ) : (
        <>
          {loadState === 'loading' ? (
            <div className="html-viewer-status" aria-live="polite">
              <Loader2 size={22} className="html-viewer-spinner" aria-hidden />
              <span>Loading 3D model…</span>
            </div>
          ) : null}
          {loadState === 'error' ? (
            <div className="html-viewer-status html-viewer-status--error">
              <span>Could not load preview.</span>
              {openHref ? (
                <a href={openHref} target="_blank" rel="noopener noreferrer">
                  Open in new tab
                  <ExternalLink size={12} aria-hidden />
                </a>
              ) : null}
            </div>
          ) : null}
          {iframeSrc ? (
            <iframe
              ref={iframeRef}
              key={iframeSrc}
              src={iframeSrc}
              title={`3D model: ${title}`}
              className="html-viewer-iframe"
              sandbox="allow-scripts allow-same-origin allow-popups allow-pointer-lock allow-downloads"
            />
          ) : null}
        </>
      )}
    </div>
  );
}
